import { Nullable } from '@/types/generic';
import * as Sentry from '@sentry/react';
import { createSnowplowTracker, getSnowplowTracker, HudlDataSchemas } from '@hudl/analytics';
import { memoize } from 'lodash/fp';
import env from '@/env';

export const initialSentrySetup = (userId: string, email: Nullable<string | undefined>) => {
  Sentry.setUser({ email: email ?? undefined, id: userId });
};

export const initialiseSnowplow = memoize(async (userId: string, entityId: string, entityName: string) => {
  createSnowplowTracker({
    id: 'parachute',
    platform: 'web',
    env: env.VITE_NODE_ENV === 'production' ? 'prod' : 'thor',
    userID: userId,
  });

  const applicationEntity = HudlDataSchemas.ApplicationEntity.V1_0_0.describe({ app_name: 'HudlParachute' });
  const userOrgEntity = HudlDataSchemas.UserOrgEntity.V1_0_0.describe({ org_id: entityId, org_name: entityName });

  // this automatically sends app context in every request
  getSnowplowTracker('parachute').addGlobalContexts('parachute', [applicationEntity, userOrgEntity]);
});
